<template>
  <v-container fluid>
    <v-speed-dial
      v-model="fab"
      bottom
      right
      fixed
      open-on-hover
      :direction="'top'"
      :transition="'slide-y-reverse-transition'"
    >
      <template v-slot:activator>
        <v-btn v-model="fab" color="primary" dark fab>
          <v-icon v-if="fab">
            mdi-close
          </v-icon>
          <v-icon v-else>
            mdi-plus
          </v-icon>
        </v-btn>
      </template>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            dark
            color="green"
            v-on="on"
            @click="dialogForm = {action: 'Create Job', showForm: true,isDraft: false};currentOperation={};"
          >
            <v-icon>mdi-clipboard-plus</v-icon>
          </v-btn>
        </template>
        <span>Open Job</span>
      </v-tooltip>
      <v-tooltip left v-if="$root.hasAccess('can_create_vessel')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            dark
            color="indigo"
            v-on="on"
            @click="dialogForm = {action: 'Create PDA Job', showForm: true,isDraft: true};currentOperation={};"
          >
            <v-icon>mdi-clipboard-text</v-icon>
          </v-btn>
        </template>
        <span>Create PDA</span>
      </v-tooltip>
    </v-speed-dial>
    <v-row class="pb-5">
      <v-col cols="12" sm="6" md="4" lg="4" class="pb-0">
        <v-select
          label="Filter Jobs"
          placeholder="PDA / FDA"
          outlined
          dense
          hide-details
          v-model="currentFilter.filterType"
          prepend-inner-icon="mdi-filter"
          :items="filterTypes"
          @change="onFilterTypeChange($event)"
        ></v-select>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="4" class="pb-0">
        <v-select
          label="Job Status"
          outlined
          dense
          hide-details
          v-model="currentFilter.jobStatus"
          prepend-inner-icon="mdi-filter"
          :items="jobStatuses"
          @change="onJobStatusChange($event)"
        ></v-select>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="4" class="pb-0">
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateRangeText"
              label="Filter by ETA Date"
              readonly
              outlined
              dense
              v-bind="attrs"
              v-on="on"
              hide-details
              prepend-inner-icon="mdi-calendar"
              :append-icon="dateRangeText ? 'mdi-close' : ''"
              @click:append="clearDateRange()"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="dateRange"
            range
            scrollable
            @input="filterByDate"
          >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menu = false">Close</v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col v-if="$store.state.auth.profile.role !== 'operations'" cols="12" sm="6" md="4" lg="4" class="pb-0">
        <v-select
          label="Incharge"
          outlined
          dense
          hide-details
          v-model="currentFilter.userFilter"
          :items="users"
          item-text="name"
          item-value="id"
          clearable
          @change="onUserFilterChange($event)"
        >
          <template v-slot:item="{ item }">
            <v-list-item-title>
              {{ item.name }}
              <span v-if="!item.is_active"> (Inactive)</span>
            </v-list-item-title>
          </template>
        </v-select>
      </v-col>
      <v-col v-if="$store.state.auth.profile.role !== 'operations'" cols="12" sm="6" md="4" lg="4" class="pb-0">
        <v-select
          label="Managed By"
          outlined
          dense
          hide-details
          v-model="currentFilter.managerFilter"
          :items="managers"
          item-text="name"
          item-value="id"
          clearable
          @change="onManagerFilterChange($event)"
        >
          <template v-slot:item="{ item }">
            <v-list-item-title>
              {{ item.name }}
              <span v-if="!item.is_active"> (Inactive)</span>
            </v-list-item-title>
          </template>
        </v-select>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="4" class="pb-0 d-flex align-center" v-if="$root.hasAccess('can_manage_excel')">
        <v-btn
          color="primary"
          small
          outlined
          @click="downloadOperationsCSV"
          :loading="excelLoading"
          :disabled="excelLoading"
        >
          <v-icon left>mdi-download</v-icon>
          Download Excel
        </v-btn>
      </v-col>
    </v-row>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="currentFilter.search"
          append-icon="mdi-magnify"
          label="Search by Job Number, Vessel, Principal..."
          placeholder="Search by Job Number, Vessel, Principal..."
          single-line
          hide-details
          :no-data-text="'No data found'"
          :no-results-text="'No results found'"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="formattedHeaders"
        :items="items"
        :search="currentFilter.search"
        :loading="loading"
        :sort-by="['id']"
        :sort-desc="[true]"
        :footer-props="{
          'items-per-page-options': [10, 20, 50]
        }"
        :page.sync="pagination.current_page"
        :items-per-page.sync="pagination.per_page"
        :server-items-length="pagination.total_count"
        @update:items-per-page="updateItemsPerPage($event)"
        @update:page="updatePage($event)"
      >
        <template v-slot:item.eta="{ item }">
          <v-chip :color="item.status == 'Open' && item.eta && new Date(item.eta) < new Date() ? 'error' : ''" small :text-color="item.status == 'Open' && item.eta && new Date(item.eta) < new Date() ? 'white' : ''">
            <v-icon left size="16">mdi-clock</v-icon>
            {{ item.eta ? moment(item.eta).format('DD-MM-YYYY HH:mm') : '' }}
          </v-chip>
        </template>
        <template v-slot:item.job_name="{ item }">
          <v-btn :loading="completedLoading == item.job_name" :disabled="completedLoading == item.job_name" text @click="jobNumberClick(item)">
            <span><u>{{item.job_name}}</u></span>
          </v-btn>
        </template>
        <template v-slot:item.vessel_name="{ item }">
          <div class="d-flex align-center">
            <v-icon size="16" color="info" class="mr-2">mdi-ferry</v-icon>
            <span>{{ item.vessel_name }}</span>
          </div>
        </template>
        <template v-slot:item.customer_name="{ item }">
          <div class="d-flex align-center">
            <v-icon size="16" color="success" class="mr-2">mdi-account</v-icon>
            <span>{{ item.customer_name }}</span>
          </div>
        </template>
        <template v-slot:item.job_scope="{ item }">
          <div class="d-flex align-center">
            <v-icon size="16" color="warning" class="mr-2">mdi-briefcase</v-icon>
            <span>{{ item.job_scope }}</span>
          </div>
        </template>
        <template v-slot:item.supervisor_name="{ item }">
          <div class="d-flex align-center">
            <v-icon size="16" color="info" class="mr-2">mdi-account-tie</v-icon>
            <span>{{ item.supervisor_name }}</span>
          </div>
        </template>
        <template v-slot:item.fda="{ item }">
          <v-chip v-if="['Open', 'Review_Requested', 'Cancelled'].includes(item.status)" x-small :color="statusColorMap[item.status]">{{ item.status }}</v-chip>
          <v-btn icon @click="generateReport(item.id, false)" v-if="!item.is_draft && ['Billing', 'Completed'].includes(item.status)">
            <v-icon>mdi-file-document</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.pda="{ item }">
          <v-btn v-if="item.is_draft" icon @click="generateReport(item.id, true)">
            <v-icon>mdi-file-document</v-icon>
          </v-btn>
          <v-btn v-else-if="item.clone_id" icon @click="generateReport(item.clone_id, true)">
            <v-icon>mdi-file-document</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.vessel_report="{ item }">
          <template v-if="!item.is_draft && ['Billing', 'Completed'].includes(item.status) && $root.onlyAccountsCanAccess">
            <v-btn icon @click="generateConsolidatedPdf(item.id)">
              <v-icon>mdi-file-pdf-box</v-icon>
            </v-btn>
          </template>
          <template v-else>
            <v-btn icon @click="generateReport(item.id, false, true)" v-if="!item.is_draft">
              <v-icon>mdi-file-document</v-icon>
            </v-btn>
          </template>
        </template>
        <template v-slot:item.job="{ item }">
          <template v-if="item.clone_id">
            Converted to FDA
          </template>
          <template v-else>
            <v-btn color="success" small @click="convertToJob(item)">
              PDA Accepted
            </v-btn>
          </template>
        </template>
        <template v-slot:item.complete="{ item }">
          <v-btn 
            v-if="item.approval_closure && item.status === 'Billing' && canMarkJobComplete" 
            color="success" 
            small 
            @click="markJobComplete(item)"
          >
            Mark As Billed
          </v-btn>
        </template>
        <template v-slot:item.button="{ item }">
          <template v-if="item.is_draft && !item.clone_id">
            <v-btn style="background-color: #273978; color: white;" small @click="convertToJob(item)">
              PDA Accepted
            </v-btn>
          </template>
          <template v-else-if="!item.is_draft && item.approval_closure && item.status === 'Billing' && canMarkJobComplete">
            <v-btn color="success" small @click="markJobComplete(item)">
              Mark As Billed
            </v-btn>
          </template>
        </template>
        <template v-slot:item.cancel="{ item }">
          <v-btn
            v-if="!['Completed', 'Cancelled'].includes(item.status)"
            icon
            color="red"
            @click="cancelJob(item)"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
        <template v-slot:progress>
          <div class="full-width text-center ma-4">
            <v-progress-circular
              indeterminate
              color="primary"
              :size="60"
              :width="5"
            ></v-progress-circular>
          </div>
        </template>
      </v-data-table>
    </v-card>
    <operation-form 
      :operation="currentOperation"
      :action="dialogForm.action"
      :showForm="dialogForm.showForm"
      :isDraft="dialogForm.isDraft"
      @closeDialog="resetDialog()"
      @completeJob="markJobComplete($event)"
      @showOperation="viewJob = true;currentOperation=Object.assign({}, $event)" />
      
      <v-overlay :value="overlayLoading" class="text-center">
        <div class="pb-4">
          Generating Report...
        </div>
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
  </v-container>
</template>

<script>
  import _ from 'lodash';
  import OperationForm from './blocks/OperationForm';
  import moment from 'moment';
  export default {
    name: 's-operations',
    components: {
      OperationForm,
    },
    data() {
      return {
        menu: false,
        excelLoading: false,
        filterTypes: ['All','Proforma Disbursement Account Jobs', 'Jobs'],
        fab: false,
        dialogForm: {
          showForm: false,
          action: '',
        },
        statusColorMap: {
          Open: 'blue lighten-5',
          Review_Requested: 'orange lighten-4',
          Cancelled: 'error',
        },
        currentFilter: {
          filterType: 'All',
          jobStatus: 'Open',
          dateRangeFilter: '',
          userFilter: '',
          managerFilter: '',
          search: '',
          limit: 10,
          page: 1,
        },
        users: [],
        managers: [],
        dateRangeText: '',
        dateRange: null,
        overlayLoading: false,
        completedLoading: null,
        viewJob: false,
        /** Set when deep-linked from MSC Reports (query openFromMsc cleared after open). */
        openedFromMscReports: false,
        currentOperation: {},
        loading: false,
        jobStatuses: ['All', 'Open', 'Review_Requested', 'Billing', 'Cancelled', 'Completed'],
        headers: [
          {text: 'Job_Number', value: 'job_name', align: 'start', sortable: false},
          {text: 'Vessel', value: 'vessel_name', align: 'center', sortable: false},
          {text: 'Principal', value: 'customer_name', align: 'center', sortable: false},
          {text: 'Job Scope', value: 'job_scope', align: 'center', sortable: false},
          {text: 'Incharge', value: 'supervisor_name', align: 'center', sortable: false},
          {text: 'ETA', value: 'eta', align: 'center', sortable: false},
        ],
        items: [],
        cloned_item: [],
        pagination: {
          current_page: 1,
          per_page: 10,
          total_count: 0,
          total_pages: 0
        },
        moment,
      };
    },
    computed: {
      canMarkJobComplete() {
        return ['admin', 'accounts'].includes(this.$store.state.auth.profile.role);
      },
      formattedHeaders() {
        const headers = [...this.headers];

        if (this.currentFilter.filterType === 'Proforma Disbursement Account Jobs') {
          headers.push({ text: 'PDA', value: 'pda', align: 'center', sortable: false });
          if (this.$root.hasAccess('can_manage_actions')) {
            headers.push({ text: 'Convert To Job', value: 'job', align: 'center', sortable: false });
            headers.push({ text: 'Cancel', value: 'cancel', align: 'center', sortable: false });
          }
        } else if (this.currentFilter.filterType === 'All') {
          if (this.currentFilter.jobStatus === 'Completed') {
            return headers;
          } else {
            headers.push(
              { text: 'PDA', value: 'pda', align: 'center', sortable: false },
              { text: 'Status', value: 'fda', align: 'center', sortable: false },
              { text: 'Vessel Report', value: 'vessel_report', align: 'center', sortable: false }
            );
            if (this.$root.onlyAccountsCanAccess) {
              headers.push({ text: 'Manager', value: 'manager_name', align: 'center', sortable: false });
            }
            if (this.$root.hasAccess('can_manage_actions')) {
              headers.push({ text: 'Actions', value: 'button', align: 'center', sortable: false });
              headers.push({ text: 'Cancel', value: 'cancel', align: 'center', sortable: false });
            }
          }
        } else {
          headers.push(
            { text: 'PDA', value: 'pda', align: 'center', sortable: false },
            { text: 'Status', value: 'fda', align: 'center', sortable: false },
            { text: 'Vessel Report', value: 'vessel_report', align: 'center', sortable: false }
          );
          if (this.$root.onlyAccountsCanAccess) {
            headers.push({ text: 'Manager', value: 'manager_name', align: 'center', sortable: false });
          }
          if (this.$root.hasAccess('can_manage_actions')) {
            headers.push({
              text: 'Mark Job Complete',
              value: 'complete',
              align: 'center', sortable: false,
            });
            headers.push({ text: 'Cancel', value: 'cancel', align: 'center', sortable: false });
          }
        }
        return headers;
      },
    },
    watch: {
      'currentFilter.search'(newValue) {
        if (newValue !== undefined) {
          this.debouncedSearch();
        }
      },
      // Watch for route query changes (e.g., browser back/forward)
      '$route.query': {
        handler(newQuery) {
          // Only update if query actually changed (avoid infinite loops)
          // Skip if this is the createMode query (handled separately)
          if (newQuery.createMode || newQuery.vesselId || newQuery.customerId || newQuery.eta || newQuery.etd) {
            return;
          }
          
          const currentQuery = {
            search: this.currentFilter.search || undefined,
            filterType: this.currentFilter.filterType !== 'All' ? this.currentFilter.filterType : undefined,
            jobStatus: this.currentFilter.jobStatus || undefined,
            dateRangeFilter: this.currentFilter.dateRangeFilter || undefined,
            userFilter: this.currentFilter.userFilter ? this.currentFilter.userFilter.toString() : undefined,
            managerFilter: this.currentFilter.managerFilter ? this.currentFilter.managerFilter.toString() : undefined,
            page: this.currentFilter.page > 1 ? this.currentFilter.page.toString() : undefined,
            limit: this.currentFilter.limit !== 10 ? this.currentFilter.limit.toString() : undefined
          };
          
          // Remove undefined values for comparison
          const cleanCurrent = JSON.stringify(Object.fromEntries(
            Object.entries(currentQuery).filter(([_, v]) => v !== undefined)
          ));
          const cleanNew = JSON.stringify(Object.fromEntries(
            Object.entries(newQuery).filter(([_, v]) => v !== undefined && v !== '' && v !== null)
          ));
          
          // Only update if query is actually different
          if (cleanCurrent !== cleanNew) {
            this.readFiltersFromURL();
            // Reload operations with the new filters
            this.getOperations();
          }
        },
        deep: true
      }
    },
    methods: {
      formatIsoDateDisplay(isoDateStr) {
        if (!isoDateStr || typeof isoDateStr !== 'string') return '';
        const dOnly = moment(isoDateStr, 'YYYY-MM-DD', true);
        if (dOnly.isValid()) return dOnly.format('DD-MM-YYYY');
        const m = moment(isoDateStr);
        return m.isValid() ? m.format('DD-MM-YYYY') : isoDateStr;
      },
      debouncedSearch: _.debounce(function() {
        this.getOperations();
        this.updateURLFromFilters();
      }, 500),
      jobNumberClick(item) {
        if (['Cancelled', 'Completed', 'Billing'].includes(item.status)) {
          this.dialogForm = {action: 'View Job', showForm: true, isDraft: item.is_draft};
        } else {
          this.dialogForm = {action: 'Edit Job', showForm: true, isDraft: item.is_draft};
        }
        this.currentOperation = Object.assign({}, item);
      },
      downloadOperationsCSV() {
        const params = new URLSearchParams();
        if (this.currentFilter.filterType !== 'All') {
          params.append('filterType', this.currentFilter.filterType);
        }
        params.append('jobStatus', this.currentFilter.jobStatus);
        if (this.dateRange && this.dateRange.length === 2) {
          params.append('dateRangeFilter', this.dateRange.join(','));
        }
        const url = `/api/v1/operations.csv?download_csv=true&${params.toString()}`;

        fetch(url, {
          method: 'GET',
          headers: {
            'Accept': 'text/csv',
          },
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error('Failed to download the file');
            }
            return response.blob();
          })
          .then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `operations_${new Date().toISOString().split('T')[0]}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch((error) => {
            console.error('Error downloading the file:', error);
          });
      },
      filterByDate() {
        if (this.dateRange && this.dateRange.length === 2) {
          const [startDate, endDate] = this.dateRange.sort();
          this.dateRangeText = `${this.formatIsoDateDisplay(startDate)} - ${this.formatIsoDateDisplay(endDate)}`;
          this.currentFilter.dateRangeFilter = this.dateRange.sort().join(',');
          this.items = this.items.filter(item => {
            const jobDate = new Date(item.job_start_date);
            return (
              jobDate >= new Date(startDate) && jobDate <= new Date(endDate)
            );
          });
          this.getOperations({dateRangeFilter: this.currentFilter.dateRangeFilter});
          this.updateURLFromFilters();
        } else if (!this.dateRange || this.dateRange.length === 0) {
          // Only clear if dateRange is completely empty/null
          this.dateRangeText = '';
        }
      },
      
      clearDateRange() {
        this.dateRange = null;
        this.dateRangeText = '';
        this.currentFilter.dateRangeFilter = '';
        this.getOperations({dateRangeFilter: ''});
        this.updateURLFromFilters();
      },
      cancelJob(operation) {
        if (confirm(`Are you sure you want to cancel Job#${operation.job_name}?`)) {
          this.$api.operations.destroy(operation.id)
            .then(() => {
              this.$store.dispatch('setAlert', {
                show: true,
                message: `Job#${operation.job_name} has been cancelled successfully.`,
              });
              this.getOperations();
            })
            .catch(err => {
              this.$store.dispatch('setAlert', {
                status: 'error',
                show: true,
                message: err.message,
              });
            });
        }
      },
      generateConsolidatedPdf(operationId) {
        this.overlayLoading = true;
        this.$api.operation_billed_items.consolidated_report_all_services(operationId)
        .then(response => {
            var b = new Blob([response.data], { type: "application/pdf" });
            const url = window.URL.createObjectURL(b)
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('target', '_blank')
            document.body.appendChild(link)
            link.click()
            link.remove()

            this.$store.dispatch('setAlert', {
              status: 'success',
              show: true,
              message: 'Consolidated PDF downloaded successfully!',
            });
          }).catch(err => {
            if (err.response && err.response.data instanceof Blob) {
              const reader = new FileReader();
              reader.onload = () => {
                try {
                  const json = JSON.parse(reader.result);
                  this.$store.dispatch('setAlert', {
                    status: 'error',
                    show: true,
                    message: json.error,
                  });
                } catch (parseErr) {
                  console.error("Non-JSON blob:", reader.result);
                }
              };
              reader.readAsText(err.response.data);
            }
          }).finally(() => {
            this.overlayLoading = false;
          });
      },
      generateReport(operationId, isPda, vesselReport = false, mscReport = false) {
        this.overlayLoading = true;
        const method = mscReport ? 'generate_msc_report' : vesselReport ? 'generate_vessel_report' : 'generate_report';
        const args = method === 'generate_report' ? [operationId, isPda] : [operationId];
        this.$api.operations[method](...args)
          .then(response => {
            const url = window.URL.createObjectURL(response.data)

            const link = document.createElement('a')
            link.href = url
            link.setAttribute('target', '_blank')
            document.body.appendChild(link)
            link.click()
            link.remove()
          }).catch(err => {
            this.$store.dispatch('setAlert', {
              status: 'error',
              show: true,
              message: err.message,
            });
          }).finally(() => {
            this.overlayLoading = false;
          });
      },
      convertToJob(operation) {
        this.$api.operations.job_clone(operation.id)
          .then(response => {
            this.cloned_item = response.cloned_job[0];
            this.$store.dispatch('setAlert', {
              show: true,
              message: `Job Cloned successfully`,
            });
            this.getOperations();
            this.dialogForm.action = 'Edit Job';
            this.dialogForm.showForm = true;
            this.dialogForm.isDraft = this.cloned_item.is_draft;
            this.currentOperation = Object.assign({}, this.cloned_item);
          }).catch(err => {
            this.$store.dispatch('setAlert', {
              status: 'error',
              show: true,
              message: err.message,
            });
          }).finally(() => (this.completedLoading = null));
      },
      markJobComplete(operation) {
        if (this.completedLoading == operation.id) return;

        if (!this.canMarkJobComplete) {
          this.$store.dispatch('setAlert', {
            status: 'error',
            show: true,
            message: 'You do not have permission to mark jobs as complete.',
          });
          return;
        }

        if (!operation.billing_party_id) {
          this.$store.dispatch('setAlert', {
            status: 'error',
            show: true,
            message: 'Please assign a Billing Party to complete the job#' + operation.job_name + '!',
          });
          return;
        }

        this.completedLoading = operation.id;
        if (confirm("Completed jobs cannot be edited, Are you sure to complete this job?")) {
          this.$api.operations.completeJob(operation.id)
            .then(response => {
              this.$store.dispatch('setAlert', {
                show: true,
                message: `Job#${operation.job_name} marked as completed`,
              });
              this.getOperations();
              this.resetDialog();
            }).catch(err => {
              this.$store.dispatch('setAlert', {
                status: 'error',
                show: true,
                message: err.message,
              });
            }).finally(() => (this.completedLoading = null));
        } else {
          this.completedLoading = null;
        }
      },
      resetDialog() {
        this.dialogForm = { showForm: false, action: '', isDraft: false };
        if (this.openedFromMscReports) {
          this.openedFromMscReports = false;
          this.$router.push({ path: '/msc_reports' }).catch(() => {});
          return;
        }
        this.initOperations();
      },
      initOperations() {
        if (this.$store.state.auth.profile.role == 'manager') {
          this.currentFilter.managerFilter = this.$store.state.auth.profile.id;
          this.currentFilter.jobStatus = 'Review_Requested';
        } else if (this.$store.state.auth.profile.role == 'accounts') { 
          this.currentFilter.jobStatus = 'Billing';
        }
        this.getOperations();
      },
      updateItemsPerPage(itemsPerPage) {
        this.currentFilter.limit = itemsPerPage;
        this.currentFilter.page = 1; // Reset to first page when changing items per page
        this.getOperations();
        this.updateURLFromFilters();
      },
      updatePage(page) {
        this.currentFilter.page = page;
        this.getOperations();
        this.updateURLFromFilters();
      },
      getOperations(filter = {}) {
        const filterParams = Object.assign(this.currentFilter, filter);
        this.loading = true;
        this.$api.operations.index(filterParams)
          .then((response) => {
            this.items = response.operations;
            this.pagination = response.pagination;
            this.users = response.users;
            this.managers = response.managers;
            if (this.$route.query.openOperationId) {
              this.openOperationFromQuery(this.$route.query.openOperationId);
            }
            this.loading = false;
          }).catch((err) => {
            this.loading = false;
            this.$store.dispatch('setAlert', {
              status: 'error',
              show: true,
              message: err.message,
            });
          });
      },
      
      // Read filters from URL query params
      readFiltersFromURL() {
        const query = this.$route.query;
        
        // Read search query
        if (query.search !== undefined && query.search !== null && query.search !== '') {
          this.currentFilter.search = query.search;
        }
        
        // Read filter type
        if (query.filterType) {
          const validFilterTypes = this.filterTypes;
          if (validFilterTypes.includes(query.filterType)) {
            this.currentFilter.filterType = query.filterType;
          }
        }
        
        // Read job status
        if (query.jobStatus) {
          const validStatuses = this.jobStatuses;
          if (validStatuses.includes(query.jobStatus)) {
            this.currentFilter.jobStatus = query.jobStatus;
          }
        }
        
        // Read date range filter
        if (query.dateRangeFilter) {
          const dates = query.dateRangeFilter.split(',');
          if (dates.length === 2) {
            const [startDate, endDate] = dates.sort();
            this.currentFilter.dateRangeFilter = query.dateRangeFilter;
            this.dateRange = [startDate, endDate];
            this.dateRangeText = `${this.formatIsoDateDisplay(startDate)} - ${this.formatIsoDateDisplay(endDate)}`;
          }
        }
        
        // Read user filter (Incharge)
        if (query.userFilter) {
          const userId = parseInt(query.userFilter);
          if (!isNaN(userId)) {
            this.currentFilter.userFilter = userId;
          }
        }
        
        // Read manager filter
        if (query.managerFilter) {
          const managerId = parseInt(query.managerFilter);
          if (!isNaN(managerId)) {
            this.currentFilter.managerFilter = managerId;
          }
        }
        
        // Read pagination
        if (query.page) {
          const page = parseInt(query.page);
          if (!isNaN(page) && page > 0) {
            this.currentFilter.page = page;
            this.pagination.current_page = page;
          }
        }
        
        if (query.limit) {
          const limit = parseInt(query.limit);
          if (!isNaN(limit) && limit > 0) {
            this.currentFilter.limit = limit;
            this.pagination.per_page = limit;
          }
        }
      },
      
      // Update URL query params from current filters
      updateURLFromFilters() {
        const query = {};
        
        // Add search if present
        if (this.currentFilter.search && this.currentFilter.search.trim() !== '') {
          query.search = this.currentFilter.search.trim();
        }
        
        // Add filter type if not default
        if (this.currentFilter.filterType && this.currentFilter.filterType !== 'All') {
          query.filterType = this.currentFilter.filterType;
        }
        
        // Add job status if not default (default depends on user role, but we'll preserve it if set)
        if (this.currentFilter.jobStatus) {
          query.jobStatus = this.currentFilter.jobStatus;
        }
        
        // Add date range filter if present and not empty
        if (this.currentFilter.dateRangeFilter && this.currentFilter.dateRangeFilter.trim() !== '') {
          query.dateRangeFilter = this.currentFilter.dateRangeFilter;
        }
        
        // Add user filter if present
        if (this.currentFilter.userFilter) {
          query.userFilter = this.currentFilter.userFilter.toString();
        }
        
        // Add manager filter if present
        if (this.currentFilter.managerFilter) {
          query.managerFilter = this.currentFilter.managerFilter.toString();
        }
        
        // Add pagination (only if not on first page or default limit)
        if (this.currentFilter.page && this.currentFilter.page > 1) {
          query.page = this.currentFilter.page.toString();
        }
        
        if (this.currentFilter.limit && this.currentFilter.limit !== 10) {
          query.limit = this.currentFilter.limit.toString();
        }

        // Preserve deep-link opener flag until consumed by openOperationFromQuery.
        if (this.$route.query.openOperationId) {
          query.openOperationId = this.$route.query.openOperationId;
        }
        if (this.$route.query.openFromMsc) {
          query.openFromMsc = this.$route.query.openFromMsc;
        }
        
        // Update URL without adding to history (use replace to avoid cluttering history)
        this.$router.replace({
          query: query
        }).catch(err => {
          // Ignore navigation errors (e.g., navigating to same route)
          if (err.name !== 'NavigationDuplicated') {
            console.error('Error updating URL:', err);
          }
        });
      },
      
      // Filter change handlers that also update URL
      onFilterTypeChange(value) {
        this.getOperations({filterType: value});
        this.updateURLFromFilters();
      },
      
      onJobStatusChange(value) {
        this.getOperations({jobStatus: value});
        this.updateURLFromFilters();
      },
      
      onUserFilterChange(value) {
        this.getOperations({userFilter: value});
        this.updateURLFromFilters();
      },
      
      onManagerFilterChange(value) {
        this.getOperations({managerFilter: value});
        this.updateURLFromFilters();
      },
      async openOperationFromQuery(operationId) {
        const id = parseInt(operationId, 10);
        if (!id) return;

        let operation = (this.items || []).find((item) => Number(item.id) === id) ||
          (this.items || []).find((item) => String(item.job_name || '').trim() === String(this.$route.query.search || '').trim());

        if (!operation) {
          try {
            const response = await this.$api.operations.show({ id });
            operation = response.operation;
          } catch (err) {
            return;
          }
        }
        if (!operation) return;

        if (['Cancelled', 'Completed', 'Billing'].includes(operation.status)) {
          this.dialogForm = { action: 'View Job', showForm: true, isDraft: operation.is_draft };
        } else {
          this.dialogForm = { action: 'Edit Job', showForm: true, isDraft: operation.is_draft };
        }
        this.currentOperation = Object.assign({}, operation);

        const nextQuery = { ...this.$route.query };
        const openedFromMsc = this.$route.query.openFromMsc === '1';
        this.openedFromMscReports = openedFromMsc;
        delete nextQuery.openOperationId;
        delete nextQuery.openFromMsc;
        if (openedFromMsc) {
          this.currentFilter.search = '';
          delete nextQuery.search;
        }
        this.$router.replace({ query: nextQuery }).catch(() => {});
      }
    },
    created() {
      // Read filters from URL query params first (before initOperations)
      this.readFiltersFromURL();
      
      if (this.$route.query.createMode) {
        this.dialogForm = {
          action: `Create Job`,
          showForm: true,
          isDraft: this.$route.query.createMode === 'PDA'
        };
        this.currentOperation = Object.assign({}, {
          vessel_id: parseInt(this.$route.query.vesselId),
          card_id: parseInt(this.$route.query.customerId),
          eta: this.$route.query.eta,
          etd: this.$route.query.etd
        });
      }
      if (this.$store.state.auth.profile.role === 'accounts') {
        this.filterTypes = ['All','Proforma Disbursement Account Jobs', 'Final Disbursement Account Jobs'];
      }
      
      // After reading URL params, initialize operations
      // But don't override URL params with role-based defaults if URL params exist
      const hasURLParams = this.$route.query.search || 
                          this.$route.query.filterType || 
                          this.$route.query.jobStatus || 
                          this.$route.query.dateRangeFilter ||
                          this.$route.query.userFilter ||
                          this.$route.query.managerFilter;
      
      if (hasURLParams) {
        // If URL has params, use them directly without role-based overrides
        // But still apply role-based filters that don't conflict
        this.initOperations();
      } else {
        // Otherwise, use the normal initialization with role-based defaults
        this.initOperations();
      }
      
      // Update URL after initial load to reflect any role-based defaults or URL params
      this.$nextTick(() => {
        this.updateURLFromFilters();
        if (this.$route.query.openOperationId) {
          this.openOperationFromQuery(this.$route.query.openOperationId);
        }
      });
    },
  };
</script>